import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { ISubjectsResponse, natCerfConst } from '..';

export const getSubjects = async () => {
  const { data } = await $apiV2.get<{ data: ISubjectsResponse }>('/nat-certificate/subjects?language_id=1&year_id=2025');

  return { subjects: data.data };
};

export const useSubjects = () => {
  const { data, ...args } = useQuery({
    queryKey: [natCerfConst.queryKeys.NATIONAL_CERTIFICATE_SUBJECTS],
    queryFn: getSubjects
  });

  return { ...data, ...args };
};
